import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

/**
 * Declares a variable for the current template scope.
 *
 * Ex. Declaring a variable off template object user
 *  <br>
 * `<ng-container *ngVar="let user.name as name">
 *      {{name}}
 * </ng-container>`
 */
@Directive({
	selector: '[ngVar]'
})
export class VarDirective<T> {
	
	@Input()
	set ngVar(val: T) {
		this.context.$implicit = val;
		this.context.ngVar = val;
		
		if (!this.hasView) {
			this.viewContainer.createEmbeddedView(this.templateRef, this.context);
			this.hasView = true;
		}
	}
	
	private context = new VarDirectiveContext<T>();
	
	private hasView = false;
	
	constructor(
		private templateRef: TemplateRef<VarDirectiveContext<T>>,
		private viewContainer: ViewContainerRef
	) {}
}

export class VarDirectiveContext<T> {
	public $implicit: T = null!;
	public ngVar: T = null!;
}